import { useContext } from "react";
import { UserContext } from "./UserContext"; // Burada UserProvider import edilmeli
import SplashScreen from "../components/shared/splash";
const UserProviderGate = ({ children }) => {
  const { fetchingUser } = useContext(UserContext);

  if (fetchingUser) {
    return <SplashScreen />; // Fetch tamamlanana kadar bekletiyoruz
  }

  return children;
};

export default UserProviderGate;